<template>
  <div>
    <img  src="https://img3.quanyou.com.cn/joyNew/group1/M00/61/CE/rB8LrmcE_ByAPJtmAAJrHB7Hh7A567.png" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="stylus" scoped>
  img {
    width: 375px;
    height: 165px;
  }
</style>